import { Film } from "lucide-react";
import ComingSoon from "../components/ComingSoon.jsx";
import { useI18n } from "../lib/i18n.jsx";

export default function VideoGen() {
  const { t } = useI18n();
  return (
    <ComingSoon
      icon={Film}
      title={t("home.feature.video.title", "Video Generation")}
      subtitle={t(
        "video.unavailable",
        "Video generation is temporarily unavailable."
      )}
      detail={t(
        "video.rebuilding",
        "We are rebuilding this workspace and will bring back video generation in a future update."
      )}
    />
  );
}
